module.exports = __webpack_public_path__ + "media/images/icons/flags/JE-fd4ec06c7227d9ab14d7ab95e3784592.svg";